export const QUERY_PARAMETER_QUERY_LABEL = 'query';
export const QUERY_PARAMETER_VIEW_LABEL = 'view';
export const QUERY_PARAMETER_ONLY_ALERTS_LABEL = 'onlyAlerts';
export const BASE_URL = '/jira/ops';

export const ALERT_LIST_SPOTLIGHT_TARGETS = {
	sidebar: 'operations-alert-sidebar-target',
	alertHeader: 'operations-alert-header-target',
	alertActions: 'operations-alert-actions-target',
	alertSources: 'operations-alert-sources-target',
	alertResponders: 'operations-alert-responders-target',
} as const;
